<div class="downloads-container">
  <div class="close-icon" (click)="closeModal()">&#10005;</div>
  <h3>Downloads</h3>
  <div class="download-button">
    <span>School Prospectus</span>
    <div *ngIf="isFileAvailable" class="download">
      <mat-icon (click)="downloadFile()" [style.color]="'white'"
        >download</mat-icon
      >
    </div>
    <span *ngIf="!isFileAvailable">N/A</span>
  </div>
  <div *ngIf="isFileAvailable" class="download-button">
    <span>QR Code</span>
    <div *ngIf="isFileAvailable" class="download">
      <mat-icon (click)="downloadQrCode()" [style.color]="'white'"
        >download</mat-icon
      >
    </div>
    <span *ngIf="!isFileAvailable">N/A</span>
  </div>
</div>
